/**
 * Invoice PDF Generator
 * Generates downloadable PDFs for UGC invoices using jsPDF + HTML2Canvas
 */

export const generateInvoicePDF = (invoice, type = 'creator') => {
  // Fallback to simple text download if jsPDF not available
  const invoiceHTML = `
    <html>
      <head>
        <style>
          body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
          .header { border-bottom: 2px solid #333; padding-bottom: 20px; margin-bottom: 20px; }
          .title { font-size: 24px; font-weight: bold; }
          .subtitle { color: #666; font-size: 12px; }
          .row { display: flex; justify-content: space-between; margin: 10px 0; }
          .section { margin: 20px 0; }
          .total { font-size: 18px; font-weight: bold; color: #2ecc71; margin-top: 30px; }
          table { width: 100%; border-collapse: collapse; }
          th, td { padding: 10px; text-align: left; border-bottom: 1px solid #ddd; }
          th { background: #f5f5f5; }
        </style>
      </head>
      <body>
        <div class="header">
          <div class="title">Invoice</div>
          <div class="subtitle">#${invoice.id?.slice(0, 8).toUpperCase()}</div>
        </div>
        
        <div class="section">
          <div class="row">
            <div><strong>Status:</strong> ${invoice.status}</div>
            <div><strong>Amount:</strong> $${invoice.amount?.toFixed(2)}</div>
          </div>
          ${invoice.due_date ? `<div class="row"><strong>Due Date:</strong> ${new Date(invoice.due_date).toLocaleDateString()}</div>` : ''}
        </div>
        
        <div class="section">
          <table>
            <tr>
              <th>Description</th>
              <th>Amount</th>
            </tr>
            <tr>
              <td>Creator Earnings from ${type === 'creator' ? 'Brand' : 'Creator'} Deal</td>
              <td>$${invoice.amount?.toFixed(2)}</td>
            </tr>
          </table>
        </div>
        
        <div class="total">
          Total Due: $${invoice.amount?.toFixed(2)}
        </div>
        
        <div style="margin-top: 40px; font-size: 12px; color: #666;">
          <p>Payment terms: Net 30</p>
          <p>Thank you for your business!</p>
        </div>
      </body>
    </html>
  `;

  // Create blob and download
  const blob = new Blob([invoiceHTML], { type: 'text/html' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `invoice-${invoice.id?.slice(0, 8)}.html`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
